import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export default component$((): JSX.Element => {
  const {
    payloadToSSR: { layout },
  } = useContext(AppDataContext);

  return (
    <a class='h-9' href={layout.subHeader?.logoForLargeScreen?.value.url}>
      <img
        class='w-auto max-w-none h-full'
        width={undefined}
        height={undefined}
        src={`data:image/svg+xml,${encodeURIComponent(layout.subHeader?.logoForLargeScreen?.value.src ?? '')}`}
        alt={layout.subHeader?.logoForLargeScreen?.value.alt}
      />
    </a>
  );
});
